"use strict";
exports.__esModule = true;
exports.StepConnector = exports.StepContent = exports.StepLabel = exports.Step = exports.Stepper = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
function Stepper(props) {
    var _a = props.alignment, alignment = _a === void 0 ? 'left' : _a, _b = props.orientation, orientation = _b === void 0 ? 'horizontal' : _b, children = props.children, rest = tslib_1.__rest(props, ["alignment", "orientation", "children"]);
    return (react_1["default"].createElement(core_1.Stepper, tslib_1.__assign({ alternativeLabel: orientation === 'horizontal' && alignment === 'center', orientation: orientation }, rest), children));
}
exports.Stepper = Stepper;
function Step(props) {
    return react_1["default"].createElement(core_1.Step, tslib_1.__assign({}, props));
}
exports.Step = Step;
function StepLabel(props) {
    return react_1["default"].createElement(core_1.StepLabel, tslib_1.__assign({}, props));
}
exports.StepLabel = StepLabel;
function StepContent(props) {
    return react_1["default"].createElement(core_1.StepContent, tslib_1.__assign({}, props));
}
exports.StepContent = StepContent;
function StepConnector(props) {
    return react_1["default"].createElement(core_1.StepConnector, tslib_1.__assign({}, props));
}
exports.StepConnector = StepConnector;
//# sourceMappingURL=Stepper.js.map